import { computed } from 'vue'
import { OrderTicket } from 'app-core'

export function useOrderTickets() {

    const allOrderTickets = computed(() => OrderTicket.all())

    const activeTicketCount = computed(() =>
        allOrderTickets.value.filter(t => t.isActive()).length)

    // True when this terminal type can fiscally process orders — currently
    // cashRegister or orderingDevice (i.e., anything except a KDS terminal).
    // The register-and-shift check is performed downstream in OrderValidation.
    // Drives Hub action gating and the display-only banner.
    const canProcess = computed(() => OrderTicket.canProcess())

    return {
        orderTickets: allOrderTickets,
        activeTicketCount,
        canProcess,
    }
}
